import React, { FC } from "react";

import { ResponsiveModal } from "@UI/Components/ResponsiveModal/ResponsiveModal";
import { VStack, Stack } from "@UI/Components/Stack/Stack";
import { Button } from "@UI/Components/Button/Button";
import { Heading } from "@UI/Components/Heading/Heading";
import { Text } from "@UI/Components/Text/Text";
import { Icon } from "@UI/Components/Icon/Icon";
import { Ban } from "@UI/Components/Icons/Ban";
import { ArrowUpRightFromSquare } from "@UI/Components/Icons/ArrowUpRightFromSquare";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import useI18n from "@I18n/hooks/useI18n";
import messages from "../messages";

export interface ITaskCreationBlockedModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const TaskCreationBlockedModal: FC<ITaskCreationBlockedModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { formatMessage } = useI18n();
  const contactSupportUrl = formatMessage(
    messages["taskCreationBlockedModal.contactSupportUrl"]
  );

  return (
    <ResponsiveModal isOpen={isOpen} onClose={onClose}>
      <VStack spacing="16px" textAlign="center" pt="8px" pb="16px">
        <Icon as={Ban} boxSize="40px" color="red.500" />
        <Heading fontSize="xl">
          <FormattedMessage {...messages["taskCreationBlockedModal.title"]} />
        </Heading>
        <Text color="gray.600" fontSize="md">
          <FormattedMessage {...messages["taskCreationBlockedModal.body"]} />
        </Text>
        <Stack direction="column" w="full" spacing="8px" pt="8px">
          <Button
            as="a"
            href={contactSupportUrl}
            target="_blank"
            rel="noopener noreferrer"
            w="full"
            variant="solid"
            bg="gray.200"
            color="gray.800"
            rightIcon={<ArrowUpRightFromSquare />}
          >
            <FormattedMessage
              {...messages["taskCreationBlockedModal.contactSupportButton"]}
            />
          </Button>
          <Button w="full" colorScheme="seaGreen" onClick={onClose}>
            <FormattedMessage {...messages.returnButton} />
          </Button>
        </Stack>
      </VStack>
    </ResponsiveModal>
  );
};
